export default __webpack_public_path__ + "static/media/avatar_157.f49a4621.png";